// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderlessTableOutlinedSvg from "@fishx/icons-svg/es/asn/BorderlessTableOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderlessTableOutlinedSvg
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
export default React.forwardRef(BorderlessTableOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderlessTableOutlined.js
// module id = 2110
// module chunks = 0